import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailDocumentCapability } from '../dto/trail-document-capability';

@Injectable({
  providedIn: 'root'
})
export class TrailDocumentCapabilityService {

  private apiUrl = environment.apiRoot + '/trialdocucapacity';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(trialId: number): Observable<TrailDocumentCapability[]> {
    return this.http.get<TrailDocumentCapability[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createDocumentCapability(trailId: number): Observable<TrailDocumentCapability> {
    let model = { "id": 0, "trial_id": trailId, "capability_plot_name": "new plot" };
    return this.http.post<TrailDocumentCapability>(this.apiUrl + '/new', model);
  }

  updateDocumentCapability(model: TrailDocumentCapability): Observable<TrailDocumentCapability> {
    return this.http.put<TrailDocumentCapability>(this.apiUrl + '/update', model);
  }

  deleteDocumentCapability(trialDocumentCapabilityId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialDocumentCapabilityId=' + trialDocumentCapabilityId);
  }

}
